angular.module('spaceChat.common')
   .factory('spaceChatSvc', [ 'IHestiaRestServiceAbstractDef',
    function(IHestiaRestServiceAbstractDef) {

    var SpaceChat = function()
    {
      IHestiaRestServiceAbstractDef.apply(this, arguments);

      this.basePattern = '{host}{port}{path}/{businessArea}/{apiString}/{resource}{id}{subResource}';
      this.businessArea = 'space-chat';
      this.resource = 'chat';
    };

    return new SpaceChat();
  }])
;